// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.resize-handle[data-v-288cac82] {\n  cursor: e-resize;\n  margin-left: 4px;\n}\n.drag-col-handle[data-v-288cac82] {\n  cursor: move;\n}\n.table[data-v-288cac82] { display:table;\n}\n.row[data-v-288cac82] { display:table-row;\n}\n.cell[data-v-288cac82] {display:table-cell;\n}\n.table-purchase[data-v-288cac82] {\n  border-collapse: collapse;\n}\n.p-table-img[data-v-288cac82] {\n  background-position: center center;\n  background-size: contain;\n}\n", ""]);
// Exports
module.exports = exports;
